import React, { useState } from "react";
import AuthPage from "../layouts/SelfServeAuthPage";
import SignupForm, { SignupFormSubmitHandler } from "../components/SignupForm";
import { useNavigate } from "react-router-dom";
import getErrorMessage from "../utils/getErrorMessage";
import { toast } from "react-toastify";
import { Box, Typography } from "@mui/material";
import Link from "../components/Link";
import { doSignup } from "../clients/FixieApiClient";
import trackEvent from "../utils/trackEvent";

export interface AuthPageProps {
  postLoginCallback: () => Promise<void>;
}

export default (props: AuthPageProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit: SignupFormSubmitHandler = async (data) => {
    if (!isLoading) {
      try {
        setIsLoading(true);
        const response = await doSignup(data);
        if (response.status === 201) {
          await props.postLoginCallback();
          trackEvent('signup');
          navigate("/apps");
        } else {
          const message = await getErrorMessage(response);
          toast.error(message || "Something went wrong");
        }
      } catch (error: any) {
        toast.error("Something went wrong");
      } finally {
        setIsLoading(false);
      }
    }
  }

  return (
    <AuthPage>
      <Box>
        <Typography variant="h5">Create your Fixie account</Typography>
      </Box>
      <SignupForm onSubmit={onSubmit} isLoading={isLoading} />
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="body2">Already have a Fixie account? <Link to={'/login'} variant="body2" style={{ textDecoration: "none" }}>
          Log in
        </Link></Typography>
      </Box>
    </AuthPage>
  );
};
